import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/finance/sales-file/`,
  {},
  {
    sendSalesFileToEmail: {
      method: 'GET',
    },
  },
  { responseType: 'blob' },
);
